export type BreakMetaDataValue = { label: string; value: string }
export type BreakMetaData = Array<BreakMetaDataValue>

/**
 * Refer to categories here:
 * https://stash.arbfund.com/projects/HEL/repos/helios/browse/libs/common-models/src/main/kotlin/com/clearwateranalytics/helios/common/models/issues/categorization/IssueCategory.kt#6
 */
export enum BreakCategory {
  AMORTIZATION = 'Amortization',
  CORPORATE_ACTIONS = 'Corporate Actions',
  DISTRIBUTION = 'Distribution',
  LOT_ENTRY_AND_EXIT = 'Lot Entry and Exit',
  OTHER = 'Other',
  POSITION = 'Position',
  PRICE_AND_ANALYTICS = 'Price and Analytics',
  SECURITY_CREATION = 'Security Creation',
  TRANSACTION_BREAKS = 'Transaction Breaks',
  TRANSACTION_DATA_INTEGRITY = 'Transaction Data Integrity',
}

// only categories that support bulk edit
// perseusIssueGroup.kt - update the source
export enum IssueGroup {
  // Transaction Breaks
  UNCLEARED_TRANSACTION = 'Uncleared Transaction',
  UNENTERED_TRANSACTION = 'Unentered Transactions',
  TRADE_PROCEEDS_ERROR = 'Trade Proceeds',
  UNCLEARED_MMF = 'Uncleared MMF Trade',
  // Transaction Data Integrity
  MATURITY_NOT_AT_PAR = 'Maturity Not at Par',
  POST_DATE_BEFORE_SETTLE_DATE = 'Post Date Before Settle Date',
  COMMISSION_ON_NON_COMMISION_SECURITY = 'Commission on Non Commission Security',
  STIFF_TRADE_PRICE_NOT_ONE_ERROR = 'STIF Trade Not Priced at $1',
  DISCOUNT_SECURITY_TRADE_PRICE = 'Discount Security Trade Price',
  MISSING_COLLATERAL_BROKER = 'Missing Collateral Broker',
  MISSING_COUNTER_PARTY = 'Missing Counter Party',
  REDEMPTION_NOT_AT_PAR = 'Redemption Not at Par',
  REDEMPTION_GAIN = 'Redemption Realizes Gain',
  BAD_EFFECTIVE_REDEMPTION_PRICE = 'Bad Effective Redemption Price',
  POSITIVE_EXPENSE_TRANSACTION = 'Positive Expense Transaction',
  NEGATIVE_TRANSACTION_INCOME = 'Negative Transaction Income',
  ORPHAN_TRANSACTION = 'Orphan Transaction',
  TRADE_ACCRUED_ERROR = 'Trade Accrued',
  TRADE_FACTOR_ERROR = 'Trade Factor',
  ACCRUED_ON_PRINCIPAL_REPAYMENT = 'Accrued on Principal Repayment',
  ACCRUED_ON_CALL_REDEEM = 'Accrued on Call Redeem',
  TRADE_PRICE_VARIANCE = 'Trade Price Variance',
}

export enum ExternalFileLinkedPanel {
  CW_TRANSACTION = 'CW_TRANSACTION',
  EXT_TRANSACTION = 'EXT_TRANSACTION',
  POSITION = 'POSITIONS',
}

export enum SecurityMappingLinkedPanel {
  EXT_TRANSACTION = 'EXT_TRANSACTION',
  POSITION = 'POSITIONS',
}

export interface Break {
  id: string
  categoryName: BreakCategory
  displayName?: IssueGroup // Naming: TransactionBreaksVariancesCategory or IssueGroup?
  metaData: BreakMetaData | Record<string, unknown> //see breaks-metadata.ts for digging into the values
  message: string
}

export interface AccountInfo {
  accountType: 'simple' | 'aggregate' | 'sleeveSimple' | 'sleeveAggregate'
  accountId: number
  simpleAccountIds: number[]
}

export interface ExternalFileFilter {
  id: string
  reconDate: string
  accountId: number
  filterText: string
  panelName: ExternalFileLinkedPanel
}

export interface JobsPayload {
  userId: number
  jobIds: number[]
  accountIds: number[]
  reconDate: string
}

export interface SecurityMappingFilter {
  extTransactionId?: number
  extPostionId?: number
  extPositionCusip?: string
  cwCusip?: string
  panelName: SecurityMappingLinkedPanel
}
